import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { AzureScimIntegrationSettingMessage } from '@shared/ui/organisms/settings/AzureScimIntegrationMessage';

export function AzureActiveDirectoryPanel() {
  const { t } = useTranslation();
  return (
    <>
      <HeadlineSmall style={{ marginBottom: 16 }}>{t('company-settings-page.azure-configuration')}</HeadlineSmall>
      <AzureScimIntegrationSettingMessage style={{}} />
    </>
  );
}
